/*
 * TLH Recipes -- "Print instructions" on /pages/<mix>.
 *
 * Each recipe carries its own button, and a recipe page carries two recipes, so
 * the click has to narrow the sheet down to the one that was asked for. Rather
 * than name the theme's furniture (header, breadcrumb, footer, popups, the app
 * embeds) in a stylesheet that would go stale the moment one of them is
 * renamed, this walks from the recipe up to <body> and marks every SIBLING
 * along that path. @media print in tlh-recipes.css hides anything marked, which
 * leaves exactly one path from <body> down to the recipe -- the other recipe
 * and the rule between them included, since they are siblings too.
 *
 * Hiding with display (in the print stylesheet) rather than visibility keeps
 * the recipe in normal flow, so a recipe that runs past one page fragments the
 * way the browser expects.
 *
 * The marks come off again on afterprint. Safari never fires afterprint from a
 * programmatic print(), and a cancelled dialog is silent in some builds, so a
 * matchMedia listener and a timeout both stand behind it: whichever lands first
 * cleans up, and cleanup is idempotent.
 */
(function () {
  'use strict';

  // A page carries one cooking-instructions section, but the PDP templates pull
  // one in as well; if two ever land together, bind once.
  if (window.__tlhRecipePrint) return;
  window.__tlhRecipePrint = true;

  // The button does nothing without this file, so it is the script that puts it
  // on the page. `defer` runs before first paint, so nothing flashes.
  document.documentElement.classList.add('tlh-print-ready');

  var ACTIVE = 'tlh-print-active';
  var TARGET = 'tlh-rp__recipe--printing';
  var HIDE = 'tlh-print-hide';

  var recipe = null;
  var hidden = [];
  var timer = null;

  function reset() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    if (!recipe) return;
    for (var i = 0; i < hidden.length; i++) hidden[i].classList.remove(HIDE);
    hidden = [];
    recipe.classList.remove(TARGET);
    recipe = null;
    document.documentElement.classList.remove(ACTIVE);
  }

  function hideSiblingsUp(node) {
    for (var el = node; el && el !== document.body; el = el.parentElement) {
      var sibling = el.parentElement && el.parentElement.firstElementChild;
      for (; sibling; sibling = sibling.nextElementSibling) {
        if (sibling === el || sibling.classList.contains(HIDE)) continue;
        sibling.classList.add(HIDE);
        hidden.push(sibling);
      }
    }
  }

  function print(target) {
    reset();
    recipe = target;
    recipe.classList.add(TARGET);
    hideSiblingsUp(recipe);
    document.documentElement.classList.add(ACTIVE);

    // Let the print rules apply before the dialog samples the layout.
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        timer = setTimeout(reset, 60000);
        window.print();
      });
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-tlh-print]');
    if (!button) return;
    var target = button.closest('.tlh-rp__recipe');
    if (!target) return;
    event.preventDefault();
    print(target);
  });

  window.addEventListener('afterprint', reset);

  if (window.matchMedia) {
    var mql = window.matchMedia('print');
    var onChange = function (event) {
      if (!event.matches) reset();
    };
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else if (mql.addListener) mql.addListener(onChange);
  }
})();
